import {
  CO_COLLECTION_ADD,
  CO_COLLECTION_SUCCESS,
  CO_COLLECTION_FAIL,
  CO_GET_COLLECTION_LISTING,
  CO_GET_COLLECTION_LISTING_SUCCESS,
  CO_GET_COLLECTION_LISTING_FAILED,
  CO_COLLECTION_EDIT,
  CO_COLLECTION_EDIT_SUCCESS,
  CO_COLLECTION_EDIT_FAIL,
  CO_COLLECTION_UPDATE,
  CO_COLLECTION_UPDATE_SUCCESS,
  CO_COLLECTION_UPDATE_FAIL,
  CO_COLLECTION_DELETE,
  CO_COLLECTION_DELETE_SUCCESS,
  CO_COLLECTION_DELETE_FAIL,
  CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD,
  CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS,
  CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL,
  CO_COLLECTION_COPY,
  CO_COLLECTION_COPY_SUCCESS,
  CO_COLLECTION_COPY_FAIL,
  CO_EXPORTDOWNLOAD_PROGRESS,
  CO_EXPORTDOWNLOAD_PROGRESS_SUCCESS,
  CO_EXPORTDOWNLOAD_PROGRESS_FAIL,
  CO_ADD_MORE_TO_COLLECTION,
  CO_ADD_MORE_TO_COLLECTION_SUCCESS,
  CO_ADD_MORE_TO_COLLECTION_FAIL,
  CO_ADD_MORE_TO_COLLECTION_UPDATE,
  CO_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS,
  CO_ADD_MORE_TO_COLLECTION_UPDATE_FAIL,
  CO_GET_PRODUCTS_FOR_ADD_COLLECTION,
  CO_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS,
  CO_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL,
  CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION,
  CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS,
  CO_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL,
  CO_REFRESH_COLLECTION_COUNT,
  CO_REFRESH_COLLECTION_COUNT_SUCCESS,
  CO_REFRESH_COLLECTION_COUNT_FAIL,
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  msg: null,
  collection: null,
  collectionEdit: null,
  collectionUpdate: null,
  collectionDelete: null,
  exportCollection: null,
  collectionCopy: null,
  coExportDownloadProgress: null,
  collectionAddMore: null,
  addMoreUpdateDetails: null,
  productsForAddCollection: null,
  productsOfferForAddCollection: null,
}

export const coCollection = (state = initialState, action) => {
  switch (action.type) {
    case CO_COLLECTION_ADD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collection: action.payload,
      }
      break
    case CO_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case CO_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_GET_COLLECTION_LISTING:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case CO_GET_COLLECTION_LISTING_SUCCESS:
      state = {
        ...state,
        error: null,
        msg: null,
        loading: false,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case CO_GET_COLLECTION_LISTING_FAILED:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_COLLECTION_EDIT:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionEdit: action.payload,
      }
      break
    case CO_COLLECTION_EDIT_SUCCESS:
      if (state === null || state.collection.length === 0) {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          collection: [...state.collection, action.payload],
        }
      } else {
        state = {
          ...state,
          loading: false,
          collection: state.collection.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
      }
      break
    case CO_COLLECTION_EDIT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null, 
        msg: null,
        collectionUpdate: action.payload,
      }
      break
    case CO_COLLECTION_UPDATE_SUCCESS:
      state = { ...state, error: null, loading: false }
      break
    case CO_COLLECTION_UPDATE_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_COLLECTION_DELETE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionDelete: action.payload,
      }
      break
    case CO_COLLECTION_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: state.collection.filter(collection => {
          return collection.id !== action.payload.id
        }),
      }
      break
    case CO_COLLECTION_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        exportCollection: action.payload,
      }
      break
    case CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS:
      state = {
        ...state,
        error: null,
        msg: null,
        loading: false,
        exportCollection: action.payload,
      }
      break
    case CO_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_COLLECTION_COPY:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionCopy: action.payload,
      }
      break
    case CO_COLLECTION_COPY_SUCCESS:
      let newcol = [...state.collection, action.payload]
      newcol = newcol.sort(function (a, b) {
        return b.id - a.id || b.id.localeCompare(a.id)
      })
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: newcol,
        collectionCopy: null,
      }
      break
    case CO_COLLECTION_COPY_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_EXPORTDOWNLOAD_PROGRESS:
      state = {
        ...state,
        loading: true,
        msg: null,
        error: null,
        coExportDownloadProgress: action.payload,
      }
      break
    case CO_EXPORTDOWNLOAD_PROGRESS_SUCCESS:
      state = {
        ...state,
        error: null,
        loading: false,
        msg: null,
        coExportDownloadProgress: action.payload,
      }
      break
    case CO_EXPORTDOWNLOAD_PROGRESS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_ADD_MORE_TO_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case CO_ADD_MORE_TO_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case CO_ADD_MORE_TO_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_ADD_MORE_TO_COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        addMoreUpdateDetails: action.payload,
      }
      break
    case CO_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        addMoreUpdateDetails: null,
      }
      break
    case CO_ADD_MORE_TO_COLLECTION_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_GET_PRODUCTS_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case CO_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case CO_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        productsForAddCollection: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case CO_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case CO_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
      case CO_REFRESH_COLLECTION_COUNT:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          productsForAddCollection: null,
          productsOfferForAddCollection: action.payload,
        }
        break
      case CO_REFRESH_COLLECTION_COUNT_SUCCESS:
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          collection: state.collection.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
        break
      case CO_REFRESH_COLLECTION_COUNT_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
  }
  return state
}

export default coCollection
